<template>
    <empire-select
        v-bind="$attrs"
        :disabled="addresses.length == false || disabled"
        :fieldClass="fieldClass"
        :inputClass="[{ 'is-loading': addresses.length == false }, highlightClass]"
        :label="label"
        :labelClass="labelClass"
        :options="addresses"
        :placeholder="placeholder"
        valueFrom="id"
        :value="value"
        :name="name"
        :errors="errors"
        v-on="$listeners"
        emp-data="selectAddress"
        title="Select Cost Center"
        data-testid="select-cost-center"
        :groupBy="groupByStatus"
        :groupSort="statusOrder"
    />
</template>

<script>
import Partials from '@/use/partials';
import { defineComponent, computed } from '@vue/composition-api';
import { hasInputProps, hasInput } from '@/has';
import useHighlightsAddress from '@/use/highlightsAddress';
import EmpireSelect from 'component/shared/elements/Select';
import { useGroupByStatus } from '@/use/groups';
import { conditionalFilter, equal, filterList, inArray, all } from '@/use/filters';
import { Statuses } from 'enums';
import { statusesSortedForType } from '@/use/sort/statuses';
import useCurrentUser from 'use/currentUser';

export default defineComponent({
    name: 'SelectCostCenter',
    components: {
        EmpireSelect,
    },
    props: {
        ...hasInputProps(),
        idWhitelist: {
            type: Array,
            default: () => [],
        },
        onlyActiveOptions: {
            type: Boolean,
            default: false,
        },
        facilityId: {
            type: [Number, String],
            required: false,
        },
    },
    setup(props) {
        const { highlightClass } = useHighlightsAddress(props);
        const groupByStatus = useGroupByStatus('status_id');
        const { currentUser } = useCurrentUser();
        const statusOrder = statusesSortedForType('isAddress');

        const facilityId = computed(() => {
            return props.facilityId || currentUser.value.facilityId;
        });

        const filters = computed(() => {
            return filterList([
                conditionalFilter(equal('facility_id', facilityId.value), facilityId.value),
                conditionalFilter(inArray(props.idWhitelist, 'id'), props.idWhitelist.length),
                conditionalFilter(equal('status_id', Statuses.ACTIVE), props.onlyActiveOptions),
            ]);
        });

        const addresses = computed(() => {
            let { costCenters } = Partials.useAddressDropdowns();
            return costCenters.value.filter(all(filters.value));
        });

        return {
            ...hasInput(props),
            highlightClass,
            addresses,
            groupByStatus,
            filters,
            statusOrder,
        };
    },
});
</script>
